<template lang="pug">
.container.grid-lg
  .card.mt-2
    .card-header
      .text-bold Filtrar
    .card-body
      form-filter(@submit='fetchReport')
  .full-height.loading.loading-lg(v-if='loading')
  div(v-else-if="report.length")
    .columns
      .column.col-12.my-2(v-for="data in formattedData" :key="data.usuario.id")
        .card
          .card-header
            .h5 {{ data.usuario.nome }}
          .card-body
            table.table.table-striped
              thead
                tr
                  th {{ 'pontuacao_resumo.referencia' | tModel }}
                  th {{ 'pontuacao_resumo.coletivo' | tModel }}
                  th {{ 'pontuacao_resumo.extraordinario' | tModel }}
                  th {{ 'pontuacao_resumo.individual_liquido' | tModel }}
                  th {{ 'pontuacao_resumo.perdidos' | tModel }}
                  th {{ 'pontuacao_resumo.total' | tModel }}
              tbody
                tr(v-for="resumo in data.resumos" :key="resumo.id")
                  td {{ `${resumo.referencia}-02` | date('MM/YYYY') }}
                  td {{ resumo.coletivo | currency }}
                  td {{ resumo.extraordinario | currency }}
                  td {{ resumo.individual_liquido | currency }}
                  td {{ resumo.perdidos | currency }}
                  td {{ resumo.total | currency }}
            
</template>

<script>
import toastErrors from '@/lib/errors/toastErrors'
import FormFilter from './components/Filter.vue'
import produtividade from '@/api/indicadores/produtividade'

export default {
  data() {
    return {
      loading: false,
      report: [],
    }
  },
  computed: {
    formattedData() {
      return this.report.reduce((acc, data) => {
        const { usuario, ...resumo } = data
        if (!acc[usuario.id]) {
          acc[usuario.id] = { usuario, resumos: [] }
        }
        acc[usuario.id].resumos.push(resumo)
        return acc
      }, {})
    },
  },
  components: { FormFilter },
  methods: {
    async fetchReport(q) {
      try {
        this.loading = true
        this.report = await produtividade.resumos({ q })
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
